import React from 'react';
import HeaderSection from 'components/Resources/HeaderSection';
import { IResource } from 'utils/types';

export interface IHeaderContainer {
  content: {
    headline: string;
    slug: string;
    backgroundColor: string;
    resources: IResource[];
  };
}

export const HeaderContainer: React.FC<IHeaderContainer> = ({ content }) => {
  if (!content) {
    return null;
  }

  const { headline, backgroundColor, slug, resources } = content;

  return (
    <HeaderSection
      headline={headline}
      backgroundColor={backgroundColor}
      slug={slug}
      resources={resources}
    />
  );
};

export default HeaderContainer;
